import Constants from '@shared/constants';
import { CARD_STATES } from '@shared/constants/workflow/WorkflowCardStatusConstant';
import { getPercentageOfTotal } from '@domain/cards/card-manual/subtask/subtask.utils';

const { CARD_CONTROL_TYPES } = Constants;

const getTextWidth = shouldDisplayStoryPoints => (shouldDisplayStoryPoints ? '280px' : '100%');
const cardHasStoryPoints = card => card.story_points !== 0;
export const cardIsAutomatic = card => card.control_type === CARD_CONTROL_TYPES.SEMI_AUTOMATIC
|| card.control_type === CARD_CONTROL_TYPES.AUTOMATIC
|| card.control_type === CARD_CONTROL_TYPES.SUGGESTION;


export const getCardFlags = (card, isDragging) => {
    const {
        is_read_only: isCardReadOnly,
        subtasks,
    } = card;

    const isAutomaticCard = cardIsAutomatic(card);

    const percentageOfConcludedSubTasks = getPercentageOfTotal(subtasks);
    const isCardNotDone = card.status !== CARD_STATES.DONE;
    const cardIsNotEditing = !card.editing;
    const shouldDisplayPanelBoard = cardIsNotEditing && !isDragging && !isCardReadOnly;

    const cardIsNotAutomatic = !isAutomaticCard;
    const cardWithStoryPoints = cardHasStoryPoints(card);
    const shouldDisplayStoryPoints = cardIsNotAutomatic && cardWithStoryPoints
  && isCardNotDone && !card.temporaryId;

    const textWidth = getTextWidth(shouldDisplayStoryPoints);

    return {
        isAutomaticCard,
        percentageOfConcludedSubTasks,
        isCardNotDone,
        cardIsNotEditing,
        shouldDisplayPanelBoard,
        cardIsNotAutomatic,
        cardWithStoryPoints,
        shouldDisplayStoryPoints,
        textWidth,
    };
};
